import { render, staticRenderFns } from "./electronicReceiptList.vue?vue&type=template&id=54daf48d&scoped=true"
import script from "./electronicReceiptList.vue?vue&type=script&lang=js"
export * from "./electronicReceiptList.vue?vue&type=script&lang=js"
import style0 from "./electronicReceiptList.vue?vue&type=style&index=0&id=54daf48d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54daf48d",
  null
  
)

export default component.exports